import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { getCapabilitySpecifications } from '../../capabilities-and-permissions';
import { CapabilitySpecification } from '../../capabilities-and-permissions/capability-specification.model';
import { SiteGroupV2, SiteV2 } from '../../models';
import { BasicService } from '../../services/basic.service';

@Component({
  selector: 'app-permissions-per-site',
  templateUrl: './permissions-per-site.component.html',
  styleUrls: ['./permissions-per-site.component.scss'],
})
export class PermissionsPerSiteComponent implements OnInit {
  @Input() readonly = false;
  private _items: SiteV2[] | SiteGroupV2[];
  @Input()
  get items(): SiteV2[] | SiteGroupV2[] {
    return this._items;
  }
  set items(values: SiteV2[] | SiteGroupV2[]) {
    this._items = values;
    this.initItems();
  }
  @Input() permissionsBS: BehaviorSubject<{
    columnMap: Map<number, Set<number>>;
    lineMap: Map<number, Set<number>>;
    disabledMap: Map<number, Set<number>>;
  }> = new BehaviorSubject(null);

  @Output() sitePermissionChange: EventEmitter<{ permissionId: number; siteId: number }> = new EventEmitter();
  @Output() permissionColumnChange: EventEmitter<CapabilitySpecification> = new EventEmitter();
  @Output() permissionLineChange: EventEmitter<number> = new EventEmitter();

  columnMap: Map<number, Set<number>>;
  lineMap: Map<number, Set<number>>;
  disabledMap: Map<number, Set<number>>;
  lineHeight = 60;
  // empiric height, consider 10 items.
  listHeight = 600;
  permissionsTooltips = {};
  permissionsColumns: CapabilitySpecification[] = getCapabilitySpecifications();

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private basicService: BasicService,
    @Inject('UsersRolesFactory') usersRolesService: any
  ) {
    this.permissionsTooltips = usersRolesService.getPermissionsTooltips();
  }

  ngOnInit() {
    this.permissionsBS.subscribe(result => {
      if (result) {
        const { columnMap, lineMap, disabledMap } = result;
        this.columnMap = columnMap;
        this.lineMap = lineMap;
        this.disabledMap = disabledMap;
      }
    });
  }

  private initItems() {
    /*
     * A line height is 60px. consider a maximum of 10 sites displayed at time for performances.
     * By default the virtual scroll is 600px height but fit the number of sites if the number is less than 10 sites (+header of 64 px).
     */
    const sitesNumber: number = this.items?.length || 0;
    setTimeout(() => {
      this.listHeight = Math.min(sitesNumber, 5) * this.lineHeight + 64;
    });
    (this.items || []).forEach(item => {
      if (item.isGroup) {
        item.href = this.getGroupAccountHref(item.id);
      } else {
        item.href = this.getAccountHref(item.id);
      }
    });
  }

  private getAccountHref(id: number) {
    const path = `/#/${this.alcmeonContextService.companyId}/fuse/account-edit/${id}`;
    return this.basicService.fullURLForRoutePath(path);
  }

  private getGroupAccountHref(id: number) {
    const path = `/#/${this.alcmeonContextService.companyId}/fuse/site-group-edit/${id}`;
    return this.basicService.fullURLForRoutePath(path);
  }
}
